import { useQueryWithSSRErrors } from "@/shared/hooks";
import { PaymentQuery } from "../graphql";
import type {
  PaymentQueryType,
  PaymentQueryVariablesType,
} from "@/types/graphql/site.generated";

const POLL_INTERVAL_MS = 5000;

export function usePayment(id: string) {
  const { data, loading, error, stopPolling } = useQueryWithSSRErrors<
    PaymentQueryType,
    PaymentQueryVariablesType
  >(PaymentQuery, {
    variables: { id },
    pollInterval: POLL_INTERVAL_MS,
    fetchPolicy: "network-only",
  });

  const status = data?.payment?.status;

  // Stop polling once we've reached any state the UI treats as terminal:
  // a resolved non-pending status, a GraphQL/network error, or a poll that
  // resolved with no status at all (payment: null, no error) — otherwise
  // Apollo keeps re-firing the query every 5s while the UI already shows a
  // terminal/stuck screen (Task 17 review round 2).
  if (
    (status && status !== "PENDING") ||
    error ||
    (!loading && data && !status)
  ) {
    stopPolling();
  }

  return { status, loading, error };
}
